import { Stack } from "@mui/material";

export const Column = ({ sx, className, ...props }) => {
  return (
    <Stack
      className={`Column ${className}`}
      direction="column"
      sx={{ flex: 1, ...sx }}
      {...props}
    >
      {props.children}
    </Stack>
  );
};
